module.exports = __webpack_public_path__ + "img/colmedica_logo.73b848ec.png";